var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createAction, createReducer, createSelector } from '@reduxjs/toolkit';
import { sortConfig, sortDirection, sortPrimaryKey, } from '../../components/SpecialOffers/constants';
import hondaRestApi from '../apis/hondaRestApi';
export var INITIAL_STATE = {
    trimsWithPaymentAndOffers: [],
    pendingPaymentKeys: [],
    isLoyaltyFilterChecked: false,
    sortBy: null,
    sortWeightLookup: null,
};
export var setIsLoyaltyFilterChecked = createAction('specialOffers/toggleIsLoyaltyFilterChecked');
export var sortByKey = createAction('specialOffers/sortByKey');
export var setTrimsWithPaymentAndOffers = createAction('specialOffers/setTrimsWithPaymentAndOffers');
var getTrimEntryKey = function (trim) {
    return [trim === null || trim === void 0 ? void 0 : trim.modelYear, trim.modelKey, trim.trimKey, trim.transmissionKey].join('-');
};
var specialOffersReducer = createReducer(INITIAL_STATE, function (builder) {
    builder
        .addCase(setTrimsWithPaymentAndOffers, function (state, action) {
        var trims = action.payload;
        state.trimsWithPaymentAndOffers = trims;
        state.sortWeightLookup = trims.reduce(function (lookup, trim) {
            var _a;
            var _b, _c, _d, _e;
            lookup[getTrimEntryKey(trim)] = (_a = {},
                _a[sortPrimaryKey.price] = (_d = (_c = (_b = trim.payment) === null || _b === void 0 ? void 0 : _b.sellingPrice) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : 0,
                _a[sortPrimaryKey.modelYear] = parseInt((_e = trim.modelYear) !== null && _e !== void 0 ? _e : '0', 10),
                _a[sortPrimaryKey.payment] = 0,
                _a);
            return lookup;
        }, {});
    })
        .addCase(setIsLoyaltyFilterChecked, function (state, action) {
        state.isLoyaltyFilterChecked = action.payload;
    })
        .addCase(sortByKey, function (state, action) {
        state.sortBy = action.payload;
    })
        .addMatcher(hondaRestApi.endpoints.getPayment.matchFulfilled, function (state, action) {
        var payment = action.payload.transformedData;
        if (!state.trimsWithPaymentAndOffers.length || !payment)
            return state;
        var _loop_1 = function (trim) {
            // eslint-disable-next-line no-continue
            if (trim.transmissionKey !== payment.detKeys.transmissionKey)
                return "continue";
            trim.payment = payment;
            state.pendingPaymentKeys = state.pendingPaymentKeys.filter(function (key) { return key !== trim.transmissionKey; });
            return "break";
        };
        // eslint-disable-next-line no-restricted-syntax
        for (var _i = 0, _a = state.trimsWithPaymentAndOffers; _i < _a.length; _i++) {
            var trim = _a[_i];
            var state_1 = _loop_1(trim);
            if (state_1 === "break")
                break;
        }
    })
        .addMatcher(hondaRestApi.endpoints.getPayment.matchRejected, function (state, action) {
        var transmissionKey = action.meta.arg.originalArgs.body.transmissionKey;
        if (!state.trimsWithPaymentAndOffers.length || !transmissionKey)
            return state;
        state.pendingPaymentKeys = state.pendingPaymentKeys.filter(function (key) { return key !== transmissionKey; });
    })
        .addMatcher(hondaRestApi.endpoints.getPayment.matchPending, function (state, action) {
        var transmissionKey = action.meta.arg.originalArgs.body.transmissionKey;
        if (!state.trimsWithPaymentAndOffers.length || !transmissionKey)
            return state;
        state.pendingPaymentKeys.push(transmissionKey);
    });
});
var isValidNumber = function (value) { return !Number.isNaN(value) && Number.isFinite(value); };
/**
 * Creates a sort function based on the specified direction and comparison weight.
 *
 * @param {SortDirection} direction - The direction to sort by, either ascending or descending.
 * @param {function} getCompareWeight -  A function that extracts the numeric value to compare from each trim.
 * @return {*}  {SortFunction}
 */
var createSortFunction = function (direction, getCompareWeight) {
    return function (a, b) {
        var valueA = getCompareWeight(a);
        var valueB = getCompareWeight(b);
        if ([valueA, valueB].some(function (value) { return !isValidNumber(value); }))
            return 0;
        return direction === sortDirection.ascending ? valueA - valueB : valueB - valueA;
    };
};
var sortTrimBySelectedOption = function (trims, sortBy, sortWeightLookup) {
    if (!sortBy || !sortConfig[sortBy] || !sortWeightLookup || !trims.length)
        return trims;
    var _a = sortConfig[sortBy], key = _a.sortByKey, direction = _a.direction;
    var sortFunction;
    switch (key) {
        case sortPrimaryKey.price:
            sortFunction = createSortFunction(direction, function (trim) { var _a, _b; return (_b = (_a = sortWeightLookup[getTrimEntryKey(trim)]) === null || _a === void 0 ? void 0 : _a.price) !== null && _b !== void 0 ? _b : 0; });
            break;
        case sortPrimaryKey.modelYear:
            sortFunction = createSortFunction(direction, function (trim) { var _a, _b; return (_b = (_a = sortWeightLookup[getTrimEntryKey(trim)]) === null || _a === void 0 ? void 0 : _a.modelYear) !== null && _b !== void 0 ? _b : 0; });
            break;
        case sortPrimaryKey.payment:
            // TODO: https://hondaca.atlassian.net/browse/APT-310
            return trims;
        default:
            return trims;
    }
    return __spreadArray([], trims, true).sort(sortFunction);
};
export var selectTrimsWithPaymentAndOffers = createSelector(function (state) { return state.specialOffers.trimsWithPaymentAndOffers; }, function (state) { return state.specialOffers.sortBy; }, function (state) { return state.specialOffers.sortWeightLookup; }, sortTrimBySelectedOption);
export var selectIsLoyaltyFilterChecked = function (state) { return state.specialOffers.isLoyaltyFilterChecked; };
export var selectIsTrimPaymentLoading = function (state, transmissionKey) {
    return state.specialOffers.pendingPaymentKeys.includes(transmissionKey);
};
export var selectSortBy = function (state) { return state.specialOffers.sortBy; };
export default specialOffersReducer;
